import styled from "styled-components";
import { Button, Container } from "react-bootstrap";
import { colors, types } from "../../../libs";

export const StyledContainer = styled(Container)`
  padding-top: 16px;
  max-width: 1111px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const HeaderLeftSection = styled.div`
${types.headers.itemMedium};
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  svg {
    cursor: pointer;
  }
`;

export const Description = styled.p`
 ${types.body.normal};
  color: ${colors.text.gray};
  margin-top: 16px;
`;

export const DashboardSearchWrapper = styled.div``;

export const SearchBarWrapper = styled.div`
  position: relative;
  width: 254px;
`;

export const SearchInput = styled.input`
  width: 100%;
  border-radius: 20px;
  padding: 8px 50px;
  background: ${colors.background.smokyBlack};;
  color: ${colors.text.white};
  border: 1px solid rgba(255, 255, 255, 0.2);
  &:focus {
    outline: none;
  }
`;

export const SearchIcon = styled.img`
  position: absolute;
  left: 20px;
  top: 14px;
  z-index: 1;
`;

export const CustomButton = styled(Button)`
 background: ${colors.background.lightBlack};
  color: ${colors.text.white};
  padding: 8px 16px; 
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap; 
  &:hover {
    background:  ${colors.background.lightGrey};
  }
`;

export const HeaderRightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;